import { render, staticRenderFns } from "./ghost.vue?vue&type=template&id=c103abca&"
import script from "./ghost.vue?vue&type=script&lang=js&"
export * from "./ghost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports